export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/village/queryPage?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
          data
        });
      },

      notifyPayAndSaveLog(data){
          return http.json({
              url: '/message/log/notifyPayAndSaveLog?id='+data.id+'&type='+data.type+'&content='+data.content,
              data
          })
      },
      tree(data){
          return http.json({
              url: '/windows/village-pay-message/tree',
              data
          })
      },
      pushPrecinctInfo(data){
          return http.json({
              url: '/windows/village-pay-message/pushPrecinctInfo',
              data
          })
      },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/message.js